module.exports = __webpack_public_path__ + "img/athletics_icon_0.ec041ad0.png";